import React from "react";
import { CopyContainer } from "./copyrightStyles";

const CopyrightText: React.FC = () => {
  return <CopyContainer>© {new Date().getFullYear()} SWCA, All Rights Reserved</CopyContainer>;
};

export default CopyrightText;
